import { render, staticRenderFns } from "./WorkPanel.vue?vue&type=template&id=6c08ac5e&scoped=true&"
import script from "./WorkPanel.vue?vue&type=script&lang=js&"
export * from "./WorkPanel.vue?vue&type=script&lang=js&"
import style0 from "./WorkPanel.vue?vue&type=style&index=0&id=6c08ac5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08ac5e",
  null
  
)

export default component.exports